// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1lR8m","paramInput":"JobSimulator_paramInput__3jvpu","input":"JobSimulator_input__1o8eI"};